






import { Data } from '@/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import OperatersBar from "@/components/OperatersBar.vue"

@Component({ components : { OperatersBar }})
export default class OperatersBarWrapper extends Vue {

@Prop({default : undefined})
private data! : Data | undefined;

}
